import { useContext } from 'react';
import { BrowserTabsContext, BrowserTabsContextType } from './BrowserTabsContext';

export const useBrowserTabs = (): BrowserTabsContextType => {
  const context = useContext(BrowserTabsContext);
  if (context === undefined) {
    throw new Error('useBrowserTabs must be used within a BrowserTabsProvider');
  }
  return context;
};
